import React from "react";
import { Form, FormControl } from "react-bootstrap";
import ValidationHelper from "../../../../helpers/ValidationHelper";
import CamplaCoreService from "../../../../services/CamplaCoreService";
import { withTranslation } from "react-i18next";
import BaseDialog from "../../../../components/dialogs/baseDialog/BaseDialog";
import BaseSelect from "../../../../components/baseSelect/BaseSelect";

//TODO: Code duplication create / update
class UpdateModuleClassDialog extends React.Component {
  constructor(props) {
    super(props);

    this.semesterOptions = [
      { value: "spring", label: "ModuleClasses.SemesterSpring" },
      { value: "fall", label: "ModuleClasses.SemesterFall" }
    ];

    const semesterMap = new Map();
    this.semesterOptions.forEach(s => semesterMap.set(s.value, s));

    this.validationDefinition = {
      moduleId: {
        defaultValue: "",
        rule: ValidationHelper.isID
      },
      classId: {
        defaultValue: "",
        rule: ValidationHelper.isID
      },
      isFall: {
        defaultValue: true,
        rule: ValidationHelper.isBoolean
      },
      year: {
        defaultValue: parseInt(new Date().getFullYear()),
        initValid: true,
        rule: ValidationHelper.isYear
      }
    };

    this.state = {
      semesterMap: semesterMap,
      validation: ValidationHelper.getValidation(this.validationDefinition)
    };

    this.handleChange = this.handleChange.bind(this);
    this.resolveOptionById = this.resolveOptionById.bind(this);
    this.translateOptions = this.translateOptions.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.onHide = this.onHide.bind(this);
  }

  resolveOptionById(id, map, property) {
    return {
      value: id,
      label: map.has(id) ? map.get(id)[property] : ""
    };
  }

  translateOptions(t, options) {
    if (Array.isArray(options)) {
      return options.map(o => ({ value: o.value, label: t(o.label) }));
    } else {
      return { value: options.value, label: t(options.label) };
    }
  }

  handleChange(event) {
    this.setState({
      validation: ValidationHelper.update(event, this.state.validation)
    });
  }

  componentDidUpdate(prevProps) {
    if (this.props.moduleClass && prevProps.show !== this.props.show) {
      this.setState({
        validation: ValidationHelper.getValidation(
          {
            moduleId: {
              defaultValue: this.props.moduleClass.moduleId,
              rule: ValidationHelper.isID
            },
            classId: {
              defaultValue: this.props.moduleClass.classId,
              rule: ValidationHelper.isID
            },
            isFall: {
              defaultValue: this.props.moduleClass.isFall,
              rule: ValidationHelper.isBoolean
            },
            year: {
              defaultValue: this.props.moduleClass.year,
              rule: ValidationHelper.isYear
            }
          },
          true
        )
      });
    }
  }

  onHide() {
    this.props.onHide(ValidationHelper.hasChanged(this.state.validation));
  }

  onSubmit() {
    if (this.state.validation._isValid) {
      const validatedData = ValidationHelper.getData(this.state.validation);
      validatedData["userId"] = CamplaCoreService.getAuthenticatedUser()._id;
      this.props.onSubmit(validatedData);
    }
  }

  render() {
    const { t } = this.props;
    return (
      <BaseDialog
        show={this.props.show}
        onHide={this.onHide}
        rightButtonCallback={this.onSubmit}
        title={t("ModuleClasses.ModuleClassModal.Form.Module")}
        rightButtonText={t("ModuleClasses.ModuleClassModal.Form.Submit")}
        leftButtonText={t("DialogCancel")}
        rightButtonVariant="green"
        leftButtonVariant="black"
        leftButtonCallback={this.onHide}
        dialogApiError={this.props.dialogApiError}
        rightButtonDisabled={!this.state.validation._isValid}
        body={(<Form onSubmit={this.onSubmit}>
          <Form.Group controlId="formBasicModules">
            <Form.Label>
              {t("ModuleClasses.ModuleClassModal.Form.Module")}
            </Form.Label>
            <BaseSelect
              options={this.props.modules}
              value={this.resolveOptionById(
                this.state.validation.moduleId.value,
                this.props.modulesMap,
                "name"
              )}
              placeholder={t(
                "ModuleClasses.ModuleClassModal.Form.ModulePlaceholder"
              )}
              onChange={s =>
                this.handleChange({
                  target: {
                    name: "moduleId",
                    value: s.value
                  }
                })
              }
            />
            <Form.Control
              type="hidden"
              isInvalid={!this.state.validation.moduleId.isValid}
            />
            <Form.Control.Feedback type="invalid">
              {t("ModuleClasses.ModuleClassModal.ValidationError.ModuleId")}
            </Form.Control.Feedback>
          </Form.Group>
          <Form.Group controlId="formBasicClass">
            <Form.Label>
              {t("ModuleClasses.ModuleClassModal.Form.Class")}
            </Form.Label>
            <BaseSelect
              onChange={s =>
                this.handleChange({
                  target: {
                    name: "classId",
                    value: s.value
                  }
                })
              }
              options={this.props.classes}
              placeholder={t(
                "ModuleClasses.ModuleClassModal.Form.ClassPlaceholder"
              )}
              value={this.resolveOptionById(
                this.state.validation.classId.value,
                this.props.classesMap,
                "name"
              )}
            />
            <Form.Control
              type="hidden"
              isInvalid={!this.state.validation.classId.isValid}
            />
            <Form.Control.Feedback type="invalid">
              {t("ModuleClasses.ModuleClassModal.ValidationError.ClassId")}
            </Form.Control.Feedback>
          </Form.Group>
          <Form.Group controlId="formBasicYear">
            <Form.Label>
              {t("ModuleClasses.ModuleClassModal.Form.Year")}
            </Form.Label>
            <FormControl
              type="number"
              min={new Date().getFullYear() - 5}
              max={new Date().getFullYear() + 5}
              value={this.state.validation.year.value}
              isInvalid={!this.state.validation.year.isValid}
              onChange={event =>
                this.handleChange({
                  target: {
                    name: "year",
                    value: parseInt(event.target.value)
                  }
                })
              }
              onBlur={event => {
                const val = parseInt(event.target.value);
                const currentYear = new Date().getFullYear();
                this.handleChange({
                  target: {
                    name: "year",
                    value:
                      val > currentYear - 5 && val < currentYear + 5
                        ? val
                        : currentYear
                  }
                });
              }}
            />
            <Form.Control.Feedback type="invalid">
              {t("ModuleClasses.ModuleClassModal.ValidationError.Year")}
            </Form.Control.Feedback>
          </Form.Group>
          <Form.Group controlId="formBasicSemester">
            <Form.Label>
              {t("ModuleClasses.ModuleClassModal.Form.Semester")}
            </Form.Label>
            <BaseSelect
              isSearchable={false}
              options={this.translateOptions(t, this.semesterOptions)}
              onChange={selected => {
                this.handleChange({
                  target: {
                    name: "isFall",
                    value: selected.value === "fall"
                  }
                });
              }}
              placeholder={t(
                "ModuleClasses.ModuleClassModal.Form.SemesterPlaceholder"
              )}
              value={this.translateOptions(
                t,
                this.state.semesterMap.get(
                  this.state.validation.isFall.value ? "fall" : "spring"
                )
              )}
            />
            <Form.Control
              type="hidden"
              isInvalid={!this.state.validation.isFall.isValid}
            />
            <Form.Control.Feedback type="invalid">
              {t("ModuleClasses.ModuleClassModal.ValidationError.IsFall")}
            </Form.Control.Feedback>
          </Form.Group>
        </Form>)}
      />
    );
  }
}

export default withTranslation()(UpdateModuleClassDialog);
